import { apiGet, apiPost } from "@/shared/api";

/** Perché il pezzo torna: lo legge il magazzino accanto allo SKU. */
export type MotivoRientro = "reso" | "tornato_indietro" | "altro";

export const MOTIVI: ReadonlyArray<{ id: MotivoRientro; label: string }> = [
  { id: "reso", label: "Reso del cliente" },
  { id: "tornato_indietro", label: "Pacco tornato indietro" },
  { id: "altro", label: "Altro" },
];

export interface Rientro {
  id: number;
  ordine: string;
  sku: string;
  titolo: string;
  quantita: number;
  motivo: MotivoRientro;
  stato: "da_riporre" | "annullato";
  creato_da: string;
  creato_il: string;
  annullato_il: string | null;
}

export interface RigaRientro {
  sku: string;
  titolo: string;
  quantita: number;
  /** Pezzi già in lista al magazzino (0 = si può segnalare). */
  segnalati: number;
}

export interface StatoRientri {
  ordine: string;
  righe: RigaRientro[];
  rientri: Rientro[];
}

export interface EsitoRientro {
  creati: Rientro[];
  gia_segnalati: string[];
}

const BASE = "/api/rientri-magazzino";

export const leggiRientri = (ordine: string) =>
  apiGet<StatoRientri>(`${BASE}?ordine=${encodeURIComponent(ordine)}`);

export const segnalaRientro = (
  ordine: string,
  motivo: MotivoRientro,
  righe: Record<string, number>,
) => apiPost<EsitoRientro>(BASE, { ordine, motivo, righe });

export const annullaRientro = (id: number) => apiPost<Rientro>(`${BASE}/${id}/annulla`);

/** «2 pezzi» / «1 pezzo»: è quello che legge Davide nel messaggio d'esito. */
export const pezzi = (n: number): string => (n === 1 ? "1 pezzo" : `${n} pezzi`);
